module.exports = "<section class=\"login-error-wrapper\">\r\n\t<div class=\"well\">\r\n\t\t<h1 class=\"h1 text-center\">{{ctrl.errorHeading}}</h1>\r\n\r\n\t\t<div class=\"alert alert-danger\">\r\n\t\t\t<i class=\"alert-icon icon--exclamation-circle\"></i>\r\n\t\t\t<p>{{ctrl.errorMessage}}</p>\r\n\t\t</div>\r\n\t\t\r\n\t\t<div class=\"helper-message text-center\">\r\n\t\t\t<p>Need more help? <a href=\"/contact\" target=\"_blank\">Contact us</a> for more information</p>\r\n\t\t</div>\r\n\t</div>\r\n</section>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/login/login-error-template.html
 ** module id = 959
 ** module chunks = 1
 **/